import { CssBaseline, StylesProvider, ThemeProvider } from "@material-ui/core";
import firebase from "firebase";
import { parse } from "query-string";
import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import "shared/src/data/window-dataLayer";
import { setGlobalApiClient, setGlobalApiHost } from "shared/src/framework/network/api-client";
import { PollTypeEnum } from "shared/src/models/poll";
import { Analytic, setOpenDate } from "./analytic/analytic";
import App from "./App";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";
import { BrowserApiClient } from "./utils/browserApiClient";
import { setMediaHost } from "./utils/media";

const isInternalTraffic = window.location.search.slice(1).split("&").includes("internal");

if (process.env.REACT_APP_GTM_ID && !isInternalTraffic) {
    TagManager.initialize({
        gtmId: process.env.REACT_APP_GTM_ID,
    });
}

if (process.env.REACT_APP_MIXPANEL_TOKEN && !isInternalTraffic) {
    Analytic.initMixpanel(process.env.REACT_APP_MIXPANEL_TOKEN);
}

setGlobalApiClient(BrowserApiClient);
setGlobalApiHost(process.env.REACT_APP_API_HOST, false);
setMediaHost(process.env.REACT_APP_MEDIA_HOST, process.env.REACT_APP_S3_MEDIA_HOST);
setOpenDate();
firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
});

const queryStringParams = parse(window.location.search);
if (!!queryStringParams && !!queryStringParams["pt"]) {
    const pollStringTypeList = (queryStringParams["pt"] as string).split(",");
    pollStringTypeList.sort();
    const pollTypeList: string[] = [];
    pollStringTypeList.map((each) => {
        return !!parseInt(each) && !!PollTypeEnum[parseInt(each)]
            ? pollTypeList.push(PollTypeEnum[parseInt(each)])
            : null;
    });
    Analytic.setPollRequestType(pollTypeList);
} else {
    Analytic.setPollRequestType([]);
}

if (process.env.REACT_APP_NAME) {
    Analytic.setAppName(process.env.REACT_APP_NAME);
}

ReactDOM.render(
    <React.StrictMode>
        <StylesProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Provider store={store}>
                    <App />
                </Provider>
            </ThemeProvider>
        </StylesProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
